import React, { useRef, useCallback } from "react";
import {
  View,
  Text,
  StyleSheet,
  useWindowDimensions,
  TouchableOpacity,
} from "react-native";
import { SwiperFlatList } from "react-native-swiper-flatlist";
import TouchableOpacityLink from "../../components/touchable-opacity-link";
import CustomImage from "../../components/custom-image";
import RocketIcon from "../../../../assets/img/rocket.png";
import TmcpPrivateIcon from "../../../../assets/img/Delhi TMCP Icons-3 (1).png";

const data = [
  {
    image: RocketIcon,
    title: "TMC PRIVATE",
    description:
      "We are discussing deep tech. With AgniKul’s Srinath Ravichandran and Java Capital’s Vinod Shankar. Private is designed to be a small, quality get together.",
    date: "8 May 2026",
    time: "4:00 PM IST",
    location: "Bangalore",
    cta: "Reserve Your Seat →",
    ctaLink: "/tmc-private/building-space-tech-in-india",
  },
  {
    image: TmcpPrivateIcon,
    title: "TMC PRIVATE",
    description:
      "Discuss learnings on navigating quick commerce as a D2C brand with Simran Khara, Jatan Bawa and Soumya Kant.",
    date: "21 May 2026",
    time: "4:00 PM IST",
    location: "Gurugram",
    cta: "Reserve Your Seat →",
    ctaLink: "/tmc-private/should-d2c-brands-chase-2-hour-deliveries",
  },
];

const AdBanner = () => {
  const { width: windowWidth } = useWindowDimensions();
  const isDesktop = windowWidth > 991;
  const slideWidth = windowWidth;
  const swiperRef = useRef(null);

  const goPrev = useCallback(() => {
    const list = swiperRef.current;
    if (!list || data.length < 2) return;
    const i = list.getCurrentIndex();
    const next = i === 0 ? data.length - 1 : i - 1;
    list.scrollToIndex({ index: next, animated: true });
  }, []);

  const goNext = useCallback(() => {
    const list = swiperRef.current;
    if (!list || data.length < 2) return;
    const i = list.getCurrentIndex();
    const next = (i + 1) % data.length;
    list.scrollToIndex({ index: next, animated: true });
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.swiperShell}>
        <SwiperFlatList
          ref={swiperRef}
          autoplay
          autoplayDelay={3}
          autoplayLoop
          data={data}
          showPagination={data.length > 1}
          paginationActiveColor="#ffffff"
          paginationDefaultColor="rgba(255,255,255,0.42)"
          paginationStyle={styles.paginationWrap}
          paginationStyleItem={styles.paginationDot}
          paginationStyleItemActive={styles.paginationDotActive}
          renderItem={({ item }) => (
            <View style={[styles.slide, { width: slideWidth }]}>
              <View
                style={[
                  styles.innerContainer,
                  isDesktop && styles.innerContainerDesktop,
                ]}
              >
                {/* LEFT IMAGE */}
                <CustomImage
                  source={item.image}
                  webStyle={{
                    objectFit: "contain",
                    height: 120,
                    display: isDesktop ? "block" : "none",
                  }}
                  altText="Rocket"
                />

                {/* CENTER CONTENT */}
                <View style={styles.textContent}>
                  <Text style={styles.badge}>{item.title}</Text>

                  <Text
                    style={[styles.title, !isDesktop && styles.titleMobile]}
                  >
                    {item.description}
                  </Text>

                  <View
                    style={[styles.metaRow, !isDesktop && styles.metaRowMobile]}
                  >
                    <Text style={styles.metaText}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-calendar h-3.5 w-3.5"
                        aria-hidden="true"
                        style={{ width: 14, height: 14 }}
                      >
                        <path d="M8 2v4"></path>
                        <path d="M16 2v4"></path>
                        <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                        <path d="M3 10h18"></path>
                      </svg>{" "}
                      {item.date}
                    </Text>
                    <Text style={styles.metaText}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-clock h-3.5 w-3.5"
                        aria-hidden="true"
                        style={{ width: 14, height: 14 }}
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 6v6l4 2"></path>
                      </svg>{" "}
                      {item.time}
                    </Text>
                    <Text style={styles.metaText}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-map-pin h-3.5 w-3.5"
                        aria-hidden="true"
                        style={{ width: 14, height: 14 }}
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>{" "}
                      {item.location}
                    </Text>
                  </View>
                </View>

                {/* CTA */}
                <TouchableOpacityLink
                  to={{ pathname: item.ctaLink }}
                  style={{
                    borderWidth: 1,
                    borderColor: "#e5e7eb",
                    padding: 10,
                    backgroundColor: "#020618",
                  }}
                >
                  <Text style={styles.ctaText}>{item.cta}</Text>
                </TouchableOpacityLink>
              </View>
            </View>
          )}
        />
        {data.length > 1 ? (
          <>
            <TouchableOpacity
              style={[styles.arrowHit, styles.arrowLeft]}
              onPress={goPrev}
              activeOpacity={0.7}
              accessibilityRole="button"
              accessibilityLabel="Previous announcement"
            >
              <Text style={styles.arrowGlyph}>‹</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.arrowHit, styles.arrowRight]}
              onPress={goNext}
              activeOpacity={0.7}
              accessibilityRole="button"
              accessibilityLabel="Next announcement"
            >
              <Text style={styles.arrowGlyph}>›</Text>
            </TouchableOpacity>
          </>
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#2cb680",
    width: "100%",
    overflow: "hidden",
  },

  swiperShell: {
    position: "relative",
    width: "100%",
  },

  slide: {
    paddingTop: 24,
    paddingBottom: 40,
    paddingHorizontal: 44,
    backgroundColor: "#2cb680",
  },

  paginationWrap: {
    bottom: 10,
    marginVertical: 0,
    height: 20,
  },

  paginationDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginHorizontal: 4,
  },

  paginationDotActive: {
    width: 8,
    height: 8,
    borderRadius: 5,
  },

  arrowHit: {
    position: "absolute",
    top: 0,
    bottom: 0,
    justifyContent: "center",
    width: 44,
    zIndex: 10,
    paddingHorizontal: 4,
  },

  arrowLeft: {
    left: 0,
  },

  arrowRight: {
    right: 0,
  },

  arrowGlyph: {
    color: "#ffffff",
    fontSize: 36,
    lineHeight: 40,
    fontWeight: "300",
    textAlign: "center",
    textShadowColor: "rgba(0,0,0,0.35)",
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
  },

  innerContainer: {
    maxWidth: 1200,
    width: "100%",
    marginHorizontal: "auto",
    flexDirection: "column",
    gap: 16,
  },

  innerContainerDesktop: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  /* LEFT IMAGE */
  rocketImage: {
    width: "100%",
    height: 220,
    objectFit: "contain",
    display: "block",
  },
  rocketImageMobile: {
    display: "none !important",
  },

  imageText: {
    color: "#94a3b8",
    fontSize: 12,
    letterSpacing: 2,
  },

  /* CENTER CONTENT */
  textContent: {
    flex: 1,
    marginHorizontal: 20,
  },

  badge: {
    color: "#ffffff",
    fontSize: 14,
    letterSpacing: 2,
    marginBottom: 8,
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "500",
  },

  badgeLight: {
    color: "#64748b",
  },

  title: {
    color: "#ffffff",
    fontSize: 24,
    lineHeight: 32,
    fontWeight: "600",
    marginBottom: 10,
    fontFamily: "PlayfairDisplay-Bold",
    fontWeight: "700",
  },

  titleMobile: {
    fontSize: 18,
    lineHeight: 28,
    marginBottom: 12,
  },

  metaRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },

  metaRowMobile: {
    gap: 12,
  },

  metaText: {
    color: "#ffffff",
    fontFamily: "HaasGrotesk-Regular",
    fontWeight: "400",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: 4,
  },

  /* CTA */
  ctaButton: {
    borderWidth: 1,
    borderColor: "#e5e7eb",
    paddingVertical: 10,
    paddingHorizontal: 18,
    borderRadius: 6,
    alignSelf: "flex-start",
  },

  ctaText: {
    color: "#ffffff",
    fontSize: 14,
    letterSpacing: 1,
  },
});

export default AdBanner;
